import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { TranslateModule } from '@ngx-translate/core';
import { NotificationsComponent } from './notifications.component';
import { notificationStateKey } from './state/notifications.selectors';
import { NotificationsReducer } from './state/notifications.reducer';
import { NotificationsEffects } from './state/notifications.effects';
import { NotificationsService } from './notifications.service';
import { RouterLink } from '@angular/router';

@NgModule( {
  declarations: [
    NotificationsComponent,
  ],
  imports: [
    FormsModule,
    TranslateModule,
    CommonModule,
    StoreModule.forFeature( notificationStateKey, NotificationsReducer ),
    EffectsModule.forFeature( [ NotificationsEffects ] ),
    RouterLink,
  ],
  providers: [
    NotificationsService
  ],
  exports: [
    NotificationsComponent
  ]
} )
export class NotificationModule {
}
